import PropTypes from 'prop-types'
import React, { Component } from 'react'
import HeaderOne from 'draft-js-editor/lib/components/SideControl/HeaderOneButton'
import HeaderTwo from 'draft-js-editor/lib/components/SideControl/HeaderTwoButton'
import BlockButton from './BlockButton'

const styles = {
	container: {
		position: 'absolute',
		left: 0,
		top: 0,
		zIndex: 999,
	},
	inner: {
		display: 'inline-block',
		cursor: 'pointer',
		width: 24 + 24,
		//height: 24,
		border: '1px solid #f0f0f0',
		padding: 6,
		//borderRadius: '50%',
		backgroundColor: 'white',
    position: 'absolute',
    left: -29,
    borderRadius: 3,
	},
}

export default class SideControl extends Component {

	static propTypes = {
		style: PropTypes.object,
		onImageClick: PropTypes.func,
		toggleBlockType: PropTypes.func,
		selectedBlockType: PropTypes.string,

		/**
		 * The icon fill colour
		 */
		iconColor: PropTypes.string,

		/**
		 * The icon fill colour when selected
		 */
		iconSelectedColor: PropTypes.string,

    /**
     * Override the inline styles for the popover component.
     */
    popoverStyle: PropTypes.object,

    /**
     * Override the block buttons.
     */
    buttons: PropTypes.array,
	};

	static defaultProps = {
		iconColor: '#000000',
		iconSelectedColor: '#2000FF',
	};

	state = {
		moreOptionsVisible: false,
	};

	render = () => {

		const {
			iconColor,
			iconSelectedColor,
			popoverStyle,
			buttons,
			editorState,
			updateEditorState,
		} = this.props


		return <div
			style={Object.assign({}, styles.container, this.props.style)}
		>

			<div
				style={styles.inner}
			>
        <HeaderOne
          updateEditorState={updateEditorState}
          editorState={editorState}
          iconColor="grey"
          iconSelectedColor="#F7B733"
        />
        <HeaderTwo
          updateEditorState={updateEditorState}
          editorState={editorState}
          iconColor="grey"
          iconSelectedColor="#F7B733"
        />
        <BlockButton
          updateEditorState={updateEditorState}
          editorState={editorState}
          blockType="text"
        >
          Text
        </BlockButton>
        <BlockButton
          updateEditorState={updateEditorState}
          editorState={editorState}
          blockType="date"
        >
          Date
        </BlockButton>
        <BlockButton
          updateEditorState={updateEditorState}
          editorState={editorState}
          blockType="checkbox"
        >
          Checkbox
        </BlockButton>

        <BlockButton
          updateEditorState={updateEditorState}
          editorState={editorState}
          blockType="list"
        >
          List
        </BlockButton>

        <BlockButton
          updateEditorState={updateEditorState}
          editorState={editorState}
          blockType="radio"
        >
          Radio
        </BlockButton>
			</div>
		</div>
	}
}



// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/ScreenRenderer/SideControl/SideControl.js